<template>
  <div
    class="variation-availability-container"
    :class="attributeType"
  >
    <template v-if="fromPrice != null">
      <div class="availability-text">
        <template v-if="pricePrefix">
          {{ $translate("Ceres::Template.itemFrom") }}
        </template>{{ fromPrice | currency(currentVariation.prices.default.currency) }}
      </div>
    </template>
    <div
      :id="attributeId + '-' + attributeValueId "
      :class="'verfuegbarkeit availability-' + availabilityColor"
    />
  </div>
</template>
<script>
export default {
    name: "VariationSelectAvailability",
    inject: { itemId: { default: null } },
    props: { attributeType: String, attributeId: Number, attributeValueId: Number, selectedAttributes: Object, variations: Array },
    computed: {
        currentVariation ()
        {
            return this.$store.getters[`${this.itemId}/currentItemVariation`]
        },
        storedVariations ()
        {
            return this.$store.state.items[this.itemId].variationSelect.variations
        },
        availabilityColor ()
        {
            let availability = 5

            !0 === this.salable && (availability = 1)
            return availability
        },
        attributeCount ()
        {
            return this.storedVariations[0].attributes.length
        },
        matchedCombinations ()
        {
            if (this.attributeCount === 1)
            {
                return this.storedVariations.find(element => element.attributes[0].attributeValueId === this.attributeValueId)
            }
            else
            {
                const mc = this.storedVariations.filter(variation => variation.attributes.find(result => result.attributeValueId == this.attributeValueId) !== undefined)
                const selAttr = this.selectedAttributes; const currentAttributeId = this.attributeId; const currentAttributeValueId = this.attributeValueId

                return mc.filter(function (element)
                {
                    let isCorrectAttribute = true; const currentSelectedAttributes = this.selAttr

                    for (const prop in this.selAttr)
                    {
                        let isCorrectSelectedAttribute = false

                        if ((this.selAttr[prop] > 0 && prop != this.currentAttributeId) || (prop == this.currentAttributeId && this.currentAttributeValueId > 0))
                        {
                            isCorrectSelectedAttribute = element.attributes.find(function (filterElements)
                            {
                                return ((filterElements.attributeValueId === this.currentSelectedAttributes[this.prop] && filterElements.attributeId == this.prop) || (filterElements.attributeValueId == this.currentAttributeValueId && filterElements.attributeId == this.prop))
                            }, { prop, currentSelectedAttributes, currentAttributeId, currentAttributeValueId })
                            if (isCorrectSelectedAttribute === undefined || !isCorrectSelectedAttribute)
                            {
                                isCorrectAttribute = false
                            }
                        }
                    }
                    return isCorrectAttribute
                }, { selAttr, currentAttributeId, currentAttributeValueId })
            }
        },
        fromPrice ()
        {
            const combinations = this.matchedCombinations

            if (this.attributeCount === 1)
            {
                if (this.variations.find(element => element.id === combinations.variationId) !== undefined && this.variations.find(element => element.id === combinations.variationId) !== null)
                {
                    return this.variations.find(element => element.id === combinations.variationId).price
                }
                else
                {
                    return null
                }
            }
            else
            {
                if (this.matchedCombinations.length === 1)
                {
                    if (this.variations.find(element => element.id === combinations[0].variationId) !== undefined && this.variations.find(element => element.id === combinations[0].variationId) !== null)
                    {
                        return this.variations.find(element => element.id === combinations[0].variationId).price
                    }
                    else
                    {
                        return null
                    }
                }
                else
                {
                    let i

                    let price = 999999999

                    for (i = 0; i < this.matchedCombinations.length; i++)
                    {
                        let temp = price

                        if (this.variations.find(element => element.id === combinations[i].variationId) !== undefined && this.variations.find(element => element.id === combinations[i].variationId) !== null)
                        {
                            temp = this.variations.find(element => element.id === combinations[i].variationId).price
                        }

                        if (temp < price)
                        {
                            price = temp
                        }
                    }
                    if (price === 999999999)
                    {
                        price = null
                    }
                    return price
                }
            }
        },
        pricePrefix ()
        {
            return this.matchedCombinations.length > 1
        },
        salable ()
        {
            let da = false

            if (this.attributeCount === 1)
            {
                if (this.matchedCombinations)
                {
                    da = this.matchedCombinations.isSalable
                }
            }
            else
            {
                da = this.matchedCombinations.find(matches => matches.isSalable === true) !== undefined
            }
            return da
        }
    }
}
</script>
